import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { MAX_PIN_ATTEMPTS } from '../constants/pin';
import { secureStorageAdapter } from '../lib/secureStorageAdapter';

interface PinRetryState {
  // Simple state to track PIN retries
  remainingAttempts: number;
  maxAttempts: number;
  
  // Actions
  decrementAttempts: () => void;
  resetAttempts: () => void;
}

export const usePinRetryStore = create<PinRetryState>()(
  persist(
    (set, get) => ({
      remainingAttempts: MAX_PIN_ATTEMPTS, // Default to 5 attempts
      maxAttempts: MAX_PIN_ATTEMPTS,
      
      decrementAttempts: () => {
        const currentAttempts = get().remainingAttempts;
        // Just decrement the counter, but don't go below 0
        set({ remainingAttempts: Math.max(0, currentAttempts - 1) });
      },
      
      resetAttempts: () => set({ 
        remainingAttempts: get().maxAttempts
      }),
    }),
    {
      name: 'pin-retry-storage', // unique name for SecureStorage
      storage: createJSONStorage(() => secureStorageAdapter),
    }
  )
);
